import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const createAuthoringUser = api(({ email, displayName, jobTitle, company, photoURL, phone }) =>
    mutate(
        gql`
            mutation createAuthoringUser(
                $email: String!
                $displayName: String
                $jobTitle: String
                $company: String
                $photoURL: String
                $phone: String
            ) {
                createAuthoringUser(
                    email: $email
                    displayName: $displayName
                    jobTitle: $jobTitle
                    company: $company
                    phone: $phone
                    photoURL: $photoURL
                ) {
                    email
                }
            }
        `,
        { email, displayName, jobTitle, company, photoURL, phone },
        { returns: "createAuthoringUser" }
    )
)
